import(/* webpackMode: "eager" */ "/var/www/vhosts/muthueshop.com/httpdocs/src/app/page.tsx");
